import { render, staticRenderFns } from "./unitEntryByDamageType.vue?vue&type=template&id=4ff7cda8&scoped=true"
import script from "./unitEntryByDamageType.vue?vue&type=script&lang=js"
export * from "./unitEntryByDamageType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff7cda8",
  null
  
)

export default component.exports